<div class="row m-0 h-100">
  <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 LoginBg setPadding ">
    <div class="row m-0 h-100 login">
      <div class="row_tab">
        <app-header></app-header>
      </div>
      <div class="row_tab align-self-center blue_rectangle">
        <!-- <div class="col-12 align-self-center">
          <h3 class="mb-4">REGISTER A NEW BUSINESS?</h3>
        </div> -->
        <form>
          <div class="row m-0">
            <div class="col-12 retext">
              <h4 style="text-decoration: underline;">Business Registration</h4>
              <p>Please select a business type below to get started:</p>
            </div>
          </div>
        </form>
      </div>

        <div class="col-sm-10">
            <div class="buttonpadding row">

          <div class="col-sm-12 p-0">
              <button class="btn_padding control_buttons" mat-raised-button color="primaryCus" [routerLink]="['/register/user-business']" [queryParams]="{ registration: 'Cannabis'}">Licensed Cannabis Business</button>
          </div>
          <div class="col-sm-12 p-0">
              <button class="btn_padding control_buttons" mat-raised-button color="primaryCus" [routerLink]="['/register/user-business']" [queryParams]="{ registration: 'Non_Cannabis'}">Non-Cannabis Business</button>
          </div>
          <!-- <div class="col-sm-2 p-0">
            <button class="btn_padding control_buttons" mat-raised-button color="primaryCus" (click) = "notNow()">NOT NOW</button>
        </div> -->
        </div>



        </div>
        <div class="col-12">
      <app-footer></app-footer>

        </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5 pos-rel welcomeBgNew h-100">
    <app-sidescreen></app-sidescreen>
</div>
<!-- <div class="container">
      <div class="loginContainer">

      </div>
      <div class="welcomeContainer">

      </div>
  </div> -->